import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export function useTextModeration() {
  const [isChecking, setIsChecking] = useState(false);
  const { toast } = useToast();

  const moderateText = async (text: string): Promise<boolean> => {
    if (!text || !text.trim()) {
      return true; // Empty content is allowed
    }

    setIsChecking(true);
    
    try {
      const { data, error } = await supabase.functions.invoke('moderate-content', {
        body: { text: text.trim() }
      });

      if (error) {
        console.error('Moderation error:', error);
        // Fail open for better UX - allow content if moderation service fails
        toast({
          title: "Moderation service unavailable",
          description: "Your content will be posted but may be reviewed later.",
        });
        return true;
      }

      if (data?.flagged) {
        toast({
          title: "Content not allowed",
          description: data.message || "Your content contains inappropriate material. Please revise and try again.",
          variant: "destructive",
        });
        return false;
      }

      return true;
    } catch (error: any) {
      console.error('Moderation error:', error);
      // Fail open for better UX
      return true;
    } finally {
      setIsChecking(false);
    }
  };

  return {
    moderateText,
    isChecking,
  };
}
